import tw, { css, TwStyle } from 'twin.macro'

const H3Style = (overWrite?: TwStyle) =>
  css(
    tw`tracking-wider leading-normal lg:text-2xl md:text-xl text-lg font-medium`,
    overWrite && overWrite,
  )

export default H3Style
